module.exports = __webpack_public_path__ + "img/5.bcea9642.jpg";